module.exports = __webpack_public_path__ + "static/media/Premium 2.fb80fa97.svg";